export interface BookingCalendarModel {
	vehicles: VehiclesModel[];
}

export interface VehiclesModel {
	plate: string;
	model: string;
	center_legal_name: string;
	status_block: string;
	group: string;
	entries: VehicleEntryStatus[];
}

export interface VehicleEntryStatus {
	start_at: string;
	end_at: string;
	status: string;
	contingency: number | string;
}


export enum BookingCalendarStates {
	AVAILABLE = 'AVAILABLE',
	OPTIONED = 'OPTIONED',
	BOOKED = 'BOOKED',
	RENT = 'RENT',
	SUSPENDED = 'SUSPENDED',
	CONTINGENCY = 'CONTINGENCY',
	NONE = 'NONE'
}

export interface Stats {
	current_page: number;
	item_count: number;
	page_count: number;
	page_size: number;
}
